import {Input, Button, Table, DatePicker, Select, Image, Popconfirm, message, Pagination} from "antd";
import React from "react";
import {SearchOutlined, PlusSquareOutlined} from '@ant-design/icons';
import './index.sass'
import api from "../../utils/api";
import _ from 'lodash';
import UserInfo from "../../components/UserInfo";
import {MERCHANT_STATE} from "../../store/merchant";
import {TOKEN_STATE} from "../../store/token";
import {connect} from "react-redux";

const {Option} = Select;

class GoodsList extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            change_fans_flag: 0,
            createChannelShow: false,
            dataSource: [],
            page: 1,
            total: 0,
            totalD: null
        }
    }


    componentDidMount() {

    }

    componentWillMount() {
        this.getSumPro();
        this.getProducts();
    }

    shouldComponentUpdate(nextProps, nextState) {
        if (nextProps.token.value && nextProps.token.value !== this.props.token.value) {
            this.getSumPro();
            this.getProducts();
        }
        return true;
    }

    change_fans_type = (flag) => {
        this.setState({
            change_fans_flag: flag
        })
    }

    selectonChange = (val) => {
        console.log(val)
    }

    selectonSearch = (val) => {
        console.log(val)
    }

    jump = (url) => {

        this.props.history.push(url)

    }

    getSumPro = async () => {
        let res = await api('sum-product-by-merchant');
        if (res.code === 200) {
            this.setState({
                totalD: res.data
            })
        }
    }


    getProducts = async (page = 1) => {//商品列表
        this.setState({
            page
        })

        let param = {
            page,
            page_size: 15
        }

        let res = await api('get-products', param);

        if (res.code === 200) {

            for (let i in res.data) {

                let entities = res.data[i]['entities'];
                entities = _.orderBy(entities, ['price'])
                let price = entities.length === 1 ? `￥${entities[0]['price']}` : `￥${entities[0]['price']} ~ ￥${entities[entities.length - 1]['price']}`
                res.data[i]['price'] = price;
            }


            this.setState({
                dataSource: res.data,
                total: res.meta.paginate.total_count
            })
        }
    }


    delProducts = async (ctx) => {//删除商品

        let param = {
            product_ids: [ctx.id]
        }

        let res = await api('del-products', param)
        if (res.code === 200) {
            message.success('删除成功！')

            this.getProducts();
        } else {
            message.error(res.message)
        }
    }


    render() {

        const columns = [
            {
                title: '商品名称',
                dataIndex: 'name',
                key: 'name',
            },
            {
                title: '商品图片',
                render: (ctx) => {
                    return (
                        <div className='limit'>
                            <Image src={ctx.image} width={70}/>
                        </div>
                    )
                }
            },
            {
                title: '商品分类',
                render: (ctx) => {
                    return (
                        <>
                            {ctx.cates.join(',')}
                        </>
                    )
                }
            },
            {
                title: '销售价格（元）',
                render: (ctx) => {
                    return (
                        <p>{ctx.price}</p>
                    )
                }
            },
            {
                title: '创建时间',
                dataIndex: 'age',
                key: 'age',
            },
            {
                title: '操作',
                render: (ctx) => {
                    return (
                        <div className='flex'>
                            <p onClick={() => {
                                console.log(ctx)
                                this.props.history.push({
                                    pathname: '/goods/goodsEditor',
                                    state: {id: ctx.id, isEditor: true}
                                })
                            }} className='themeColor mgr10 pointer'>编辑</p>
                            <Popconfirm
                                title='确认删除该商品？'
                                cancelText='取消'
                                okText='确认'
                                onConfirm={() => {
                                    this.delProducts(ctx)
                                }}
                            >
                                <p className='warn pointer'>删除</p>
                            </Popconfirm>
                        </div>
                    )
                }
            },
        ];


        let {dataSource, page, total, totalD} = this.state
        const pagination = {
            current: page,
            total: total,
            pageSize: 15,
            onChange: (page) => {
                this.getProducts(page);
            }
        };
        return (
            <div className='goods_list'>
                <div className='channel'>
                    <div className='userList'>

                        {/* 头部 */}
                        {
                            totalD ? (<UserInfo rightBox={<ul className='flex census'>
                                <li>
                                    <label>全部商品</label>
                                    <p>{totalD.product_num}</p>
                                </li>
                                <li>
                                    <label>全部商品分类</label>
                                    <p>{totalD.cate_num}</p>
                                </li>
                            </ul>}/>) : null
                        }


                        <div className='record'>
                            <div className='change_fans flex search'>
                                <div className='flex'>
                                    <div className='flex line alignCenter'>
                                        搜索商品：
                                        <Input placeholder='搜索商品：'/>
                                    </div>

                                    <div className='flex line alignCenter'>
                                        商品分类：
                                        <Select
                                            style={{width: 200}}
                                            showSearch
                                            placeholder="全部"
                                            optionFilterProp="children"
                                            onChange={(e) => {
                                                this.selectonChange(e)
                                            }}
                                            onSearch={(e) => {
                                                this.selectonSearch(e)
                                            }}
                                            filterOption={(input, option) =>
                                                option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                        >
                                            <Option value="jack">Jack</Option>
                                            <Option value="lucy">Lucy</Option>
                                            <Option value="tom">Tom</Option>
                                        </Select>
                                    </div>

                                    <div className='flex line alignCenter'>
                                        商品销售价：
                                        <Input style={{width: 140}} placeholder='最低价格'/>
                                        ~
                                        <Input style={{width: 140}} placeholder='最高价格'/>
                                    </div>
                                    <Button icon={<SearchOutlined/>}>搜索</Button>
                                    <Button>重置</Button>
                                </div>
                                <Button
                                    onClick={() => {
                                        this.jump('/goods/goodsEditor')
                                    }}
                                    icon={<PlusSquareOutlined/>} className='createChannelBtn'>新建商品
                                </Button>
                            </div>
                            <div className='change_fans'>
                                <Table dataSource={dataSource} columns={columns} pagination={pagination} scroll={
                                    {
                                        scrollToFirstRowOnChange: false,
                                        x: false
                                    }
                                }/>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (store) => {
    return {
        merchant: store[MERCHANT_STATE],
        token: store[TOKEN_STATE]
    }
};
export default connect(mapStateToProps)(GoodsList);